export default __webpack_public_path__ + "static/media/formas-digitales-nosotros-computadora.3c12d4e8.png";